export default "__VITE_ASSET__Bxel9xfZ__"